import get from 'lodash/get'
import { PropTypes } from 'prop-types'
import { useEffect, useState } from 'react'
import { FieldArray } from 'react-final-form-arrays'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { setLimit } from '../account/booking-details/helpers'
import InclusionRow from './InclusionRow'
import ReactTooltip from 'react-tooltip'

ToggleInclusions.propTypes = {
  sectionTitle: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
}

const InclusionRowArray = ({ fields, maxDives }) => {
  const shopKind = useSelector((state) => get(state, 'selectedShop.shopKind'))
  const roomParams = useSelector((state) => state.guestsInRoom)
  const filters = useSelector((state) => ({
    nights: get(state, 'departureDate.duration'),
  }))

  // We need to check `maxDives` to update maxLimit for items that payed `per dive`. For each diver.
  useEffect(() => {
    if(shopKind === 20) {
      fields.forEach((_, index) => {
        const value = fields.value[index]
        fields.update(index, {
          ...value,
          maxLimit: setLimit(shopKind, value, {
            duration: filters.nights,
            numberOfDives: maxDives,
            diversNumber: roomParams.divers,
            totalGuests: roomParams.totalGuests,
            studentsNumber: roomParams.students,
            nonDiversNumber: roomParams.nonDivers,
            roomsNumber: get(roomParams, 'details.length'),
          }),
        })
      })
    }
  }, [maxDives, shopKind])

  return fields.map((name, index) => {
    const filedValue = fields.value[index]
    return (
      <InclusionRow
        item={filedValue}
        name={name}
        key={name + index}
        shopKind={20}
      />
    )
  })
}

export default function ToggleInclusions({
  sectionTitle,
  isStudent,
  name,
  maxDives,
}) {
  const [sectionVisible, setVisibility] = useState(false)
  const toggleSection = () => setVisibility((isVisible) => !isVisible)

  useEffect(() => {
    if(sectionVisible) {
      ReactTooltip.rebuild()
    }
  }, [sectionVisible])

  // now we don't have any items for students
  if(isStudent) {
    return (
      <div className='t-row'>
        <div className='t-cell text-center'>
          <FormattedMessage
            id='no_custom_items'
            defaultMessage='No customizable items'
          />
        </div>
      </div>
    )
  }

  return (
    <div className='t-row'>
      <div className='t-cell pointer full-mobile' onClick={toggleSection}>
        <i className='font-icons icon-plus' />
        <span className='title'>{sectionTitle}</span>
      </div>
      <div className='t-cell pointer full-mobile' onClick={toggleSection}>
        <a className={`more ${sectionVisible ? 'active' : ''}`}>
          {sectionVisible ? (
            <FormattedMessage id='hide_prices' defaultMessage='Hide prices' />
          ) : (
            <FormattedMessage id='view_prices' defaultMessage='View prices' />
          )}
        </a>
      </div>
      {sectionVisible && (
        <div className='sub'>
          <FieldArray name={name}>
            {({ fields }) => (
              <InclusionRowArray fields={fields} maxDives={maxDives} />
            )}
          </FieldArray>
        </div>
      )}
    </div>
  )
}
